<div class="content-inner loading" *ngIf="loading"></div>

<ng-template [ngIf]="!loading">      
<div class="content-inner">
    <div class="form-body" [formGroup]="totalUOSForm">
        <div class="workflow-section-heading">Enter Scheduled {{unitOfServiceName}}</div>
        <section class="workflow-input-group">
            <div class="workflow-input">
                <input type="number" min="0" formControlName="scheduledUos" id="scheduledUos">
                <span class="display-label">Scheduled</span>
                <div *ngIf="valueOutOfRange()" class="validation-message warning">
                    Value must be a whole number between {{minValue}} and {{maxValue | number}}.
                </div>
            </div>
            <div class="workflow-input" *ngIf="isAddOnsPresent(shiftRecord.shiftBlock.addOns)">
                <input type="text" disabled attr.aria-label="Add Ons" [value]="addOnsValue">
                <span class="display-label">Net Add Ons</span>
            </div>
            <div class="workflow-input totals" *ngIf="isAddOnsPresent(shiftRecord.shiftBlock.addOns)">
                <input type="text" disabled attr.aria-label="Total" [value]="totalUos">
                <span class="display-label">Total</span>
            </div>
        </section>
        <section [formGroup]="staffForm">
            <div class="workflow-section-heading">Enter Staffing Levels</div>
            <div class="loading" *ngIf="loadingRecommendations"></div>
            <ng-container *ngIf="jobTitlesWithVariance.length > 0">
              <div class="warning notification" *ngFor="let varianceWarning of getVarianceWarnings()">
                <span class="icon-notification"></span> {{ varianceWarning }}
              </div>
            </ng-container>
            <section *ngIf="shiftRecord.costCenter.variableJobTitles.length" class="workflow-input-group">
                <div class="workflow-section-subheading">Enter Variable Hours                
                   <span class="hours-calculator-link" >
                         &nbsp;&nbsp;&nbsp;
                        
                          <a  (click)="openHoursCalculator()"> 
                            <svg class="calculator-icon"> <use xlink:href="assets/symbol-defs.svg#icon-calculator"></use>  </svg>  
                            Hours Calculator</a>
                    </span>                 
                </div>
                <smt-hours-calculator 
                    (acceptEvent)="ShowHoursWarning($event)"
                    [(shiftRecord)]="shiftRecord" 
                    (rejectEvent)="CloseCalculatorModal($event)"
                    [(completedRows)] ="staffWarningRows"
                    [(targetStaffs)]="targetStaffs"
                    *ngIf="showHoursCalculatorModal">
                </smt-hours-calculator>
                <div class="workflow-input-labels">
                    <span>Target</span>
                    <span>Planned</span>
                </div>
                <div class="workflow-input" *ngFor="let varStaff of shiftRecord.costCenter.variableJobTitles">
                    <input type="text" disabled [attr.aria-label]="'Target ' + varStaff.abbreviation" [value]="getRecommendedStaffText(varStaff.id)">
                    <input type="number" min="0" [attr.aria-label]="'Actual ' + varStaff.abbreviation" [formControlName]="getStaffControlName(varStaff.id)">
                    <span class="display-label">{{ varStaff.abbreviation }}

                        <ng-container *ngIf="staffWarningRows.length > 0">
                            <span class="warning notification"  >
                                <span class="icon-notification"></span>  {{ getStaffWarning(varStaff.id)  }}
                            </span>
                          </ng-container>
                    </span>
                    <div *ngIf="controlValueOutOfRange(varStaff.id)" class="validation-message warning">
                        Value must be between {{minValue}} and {{maxValue | number}}.
                    </div>                        
                </div>
            </section>    
            <section *ngIf="shiftRecord.costCenter.fixedJobTitles.length" class="workflow-input-group">
                <a class="workflow-section-link" (click)="toggleFixedStaff()">Enter Fixed Staff</a> 
                &nbsp;
                <button class="compact" (click)="toggleFixedJobEditing(true)"><span class="icon-pencil"></span> Edit</button>
                <ng-template [ngIf]="showFixedStaff">
                    <div class="workflow-input-labels">
                        <span>Target</span>
                        <span>Planned</span>
                    </div>
                    <div class="workflow-input" *ngFor="let fixed of shiftRecord.costCenter.fixedJobTitles">
                        <input type="text" disabled [attr.aria-label]="'Target ' + fixed.abbreviation" [value]="getRecommendedStaffText(fixed.id)">
                        <input type="number" min="0" [attr.aria-label]="'Actual ' + fixed.abbreviation" [formControlName]="getStaffControlName(fixed.id)">
                        <span class="display-label">{{ fixed.abbreviation }}</span>
                        <div *ngIf="controlValueOutOfRange(fixed.id)" class="validation-message warning">
                            Value must be between {{minValue}} and {{maxValue | number}}.
                        </div>
                    </div>
                </ng-template>
            </section>
        </section>        
    </div>
</div>
</ng-template>
